import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages publiques
import Home from "./pages/public/Home";
import Contact from "./pages/public/Contact";
import AdminLogin from "./pages/public/AdminLogin";

// Pages produits (consultation libre)
import Products from "./pages/client/Products";
import ProductDetail from "./pages/client/ProductDetail";

// Pages admin
import AdminDashboard from "./pages/admin/Dashboard";
import AdminCategories from "./pages/admin/Categories";
import AdminProducts from "./pages/admin/Products";

const App: React.FC = () => {
    return (
        <AuthProvider>
            <NotificationProvider>
                <Router>
                    <Layout>
                        <Routes>
                            {/* Routes publiques */}
                            <Route path="/" element={<Home />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route
                                path="/admin/login"
                                element={<AdminLogin />}
                            />

                            {/* Produits et catégories : consultation libre, sans connexion */}
                            <Route path="/products" element={<Products />} />
                            <Route
                                path="/products/:id"
                                element={<ProductDetail />}
                            />

                            {/* Routes admin */}
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/categories"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminCategories />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/products"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminProducts />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </Layout>
                </Router>
            </NotificationProvider>
        </AuthProvider>
    );
};

export default App;
